export default "__VITE_ASSET__lEjrvqKp__"